import React from "react";
import LazyloadImage from "./LazyloadImage";
import StaticImage from "./StaticImage";

export default class HeroImage extends React.Component {
  static defaultProps = {
    containerClassName: 'hero-image-container',
    desktopWidth: 531,
    mobileWidth: 207,
    isLeadImage: false,
    isMobile: false,
    mdCrop: "rs_1062.h",
    smCrop: "rs_414.h"
  };

  render() {
    const { isLeadImage } = this.props;

    return (isLeadImage ? <StaticImage {...this.props} /> : <LazyloadImage {...this.props} />)
  }
}